import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PublisherDashboard from '../dashboards/PublisherDashboard';
import PublisherGrades from './PublisherGrades';
import PublisherSubjects from './PublisherSubjects';
import PublisherPublications from './PublisherPublications';

const PublisherRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PublisherDashboard />} />
      <Route path="/publications" element={<PublisherPublications />} />
      <Route path="/grades" element={<PublisherGrades />} />
      <Route path="/subjects" element={<PublisherSubjects />} />
    </Routes>
  );
};

export default PublisherRoutes;
